import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    permissions: [],
  },
  getters: {
    permissions: state => state.permissions,
  },
  mutations: {
    SAVE_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    CLEAR_PERMISSIONS(state) {
      state.permissions = []
    },
  },
  actions: {
    async fetch({ commit }, userId = false) {
      try {
        const resp = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/permission${userId ? `?userId=${userId}` : ''}`)
        commit('SAVE_PERMISSIONS', resp.data)
      } catch (e) {
        commit('CLEAR_PERMISSIONS')
      }
    },
    cleanPermissions({ commit }) {
      commit('CLEAR_PERMISSIONS')
    },
  },
}
